<script>
import { mapGetters, mapState } from "vuex";

export default {
  props: {
    profileOpened: {
      type: Boolean,
      required: true
    },

    fullName: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapState("orderScheduler", ["sugestionSearch"]),
    ...mapGetters("orderScheduler", ["missingRequiredFields"])
  }
};
</script>

<template>
  <div class="actions">
    <button class="button secondary" @click.stop="$emit('toogleProfile')">
      {{ profileOpened ? 'Esconder' : 'Ver' }} Perfil
    </button>

    <button class="button main" @click.stop="$emit('selectProfessional')">
      {{ missingRequiredFields || sugestionSearch ? "Abrir agenda de" : "Agendar com " }} {{ fullName }}
    </button>
  </div>
</template>

<style scoped>
.actions {
  padding: 12px;
  display: flex;
}

.button {
  width: 100%;
  height: 40px;
  border-radius: 2px;
  border-color: transparent;
  font-size: 14px;
  cursor: pointer;
}

.main {
  width: 60%;
  background: #603285;
  color: #fff;
}

.secondary {
  width: 40%;
  margin-top: 0;
  margin-right: 16px;
  color: #424242;
}

@media (max-width: 374px) {
  .actions {
    flex-direction: column;
  }

  .main {
    width: 100%;
  }

  .secondary {
    width: 100%;
    margin-left: 0;
    margin-top: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/Card/Actions.vue